module.exports = __webpack_public_path__ + "static/media/zegar_odliczajacy_czas_do_konca_rozwiazywania_zestawu_zadan.cd11816f.svg";